import { node, func, bool } from "prop-types";
export var propTypes = {
  children: node,
  isLoading: bool,
  onButtonClose: func,
  title: node,
  withCloseButton: bool
};